module.exports = __webpack_public_path__ + "static/patternBG-f25af38e357096ca23290d5f5bcb3355.png";